export default {
  related: 'Articoli correlati',
  newsletterTitle: 'Ricevi aggiornamenti sulla magia del 3D',
}
